export default "__VITE_ASSET__bsfzhwhE__"